module.exports = __webpack_public_path__ + "img/img-2-members@2x.9a2de887.png";